import * as React from 'react';

import { useDesignSystemFlags } from '../../../Hooks';
import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';

function SvgQuestionMarkFillIconV1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17v-2h2v2h-2zm3.17-6.83l.9-.92c1.02-1.02 1.37-2.77.19-4.4-.9-1.25-2.35-2.04-3.87-1.8-1.55.24-2.8 1.36-3.23 2.83C8 8.44 8.4 9 8.98 9h.3c.39 0 .7-.28.82-.65.33-.95 1.36-1.58 2.47-1.27.7.2 1.26.81 1.39 1.53.13.7-.09 1.36-.55 1.8l-1.24 1.26A3.997 3.997 0 0011 14.5v.5h2c0-.46.05-.82.13-1.14.18-.72.54-1.18 1.04-1.69z"
        fill="currentColor"
      />
    </svg>
  );
}

function SvgQuestionMarkFillIconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16A8 8 0 108 0a8 8 0 000 16zm2.207-10.189a2.25 2.25 0 01-1.457 2.56V9h-1.5V7.75A.75.75 0 018 7a.75.75 0 10-.75-.75h-1.5a2.25 2.25 0 014.457-.439zM7.25 10.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0z"
        fill="currentColor"
      />
    </svg>
  );
}

function QuestionMarkFillIcon(props: IconProps) {
  const { USE_NEW_ICONS } = useDesignSystemFlags();
  const component = USE_NEW_ICONS ? SvgQuestionMarkFillIconV2 : SvgQuestionMarkFillIconV1;
  return <Icon {...props} component={component} />;
}

export default QuestionMarkFillIcon;
